"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Measure =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Measure, _React$Component);

  function Measure() {
    var _ref;

    var _temp, _this;

    _classCallCheck(this, Measure);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_ref = Measure.__proto__ || Object.getPrototypeOf(Measure)).call.apply(_ref, [this].concat(args))), _this.state = {
      node: null,
      running: false,
      lastDimensions: null,
      dimensions: {
        height: -1,
        width: -1,
        left: -1,
        top: -1
      }
    }, _this._updateDimensions = function () {
      // guards
      if (!_this.state.node || !_this._mounted) {
        return;
      } // grab the location of the node


      var current = _this.state.node.getBoundingClientRect(); // and the last we knew about it


      var last = _this.state.lastDimensions;

      if (!last) {
        return;
      } // if the scroll height has changed


      if (_this.state.dimensions.top === -1 || current.top !== last.top || current.left !== last.left || current.width !== last.width || current.height !== last.height) {
        // update the component state
        _this.setState({
          lastDimensions: current,
          dimensions: {
            height: current.height,
            width: current.width,
            top: current.top,
            left: current.left
          }
        });
      } // we're done here so keep updating


      requestAnimationFrame(_this._updateDimensions);
    }, _this._ref = function (node) {
      // if we are attaching the node for the first time
      if (!_this.state.node) {
        // save the node in state
        _this.setState({
          node: node,
          running: true,
          lastDimensions: node.getBoundingClientRect()
        }, // start updating the position of the element when we've saved the current value
        _this._updateDimensions);
      }
    }, _this.render = function () {
      return _this.props.children(_extends({
        measureRef: _this._ref
      }, _this.state.dimensions));
    }, _temp));
  }

  _createClass(Measure, [{
    key: "componentDidMount",
    // gross hack to terminate the animation frame when this unmounts
    value: function componentDidMount() {
      this._mounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._mounted = false;
    }
  }]);

  return Measure;
}(React.Component);

var _default = Measure;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-web/components/window/Measure/index.js
// module id = ./node_modules/quark-web/components/window/Measure/index.js
// module chunks = 0